var render = function() {
  var _obj
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("b", [_vm._v("TEST")]),
    _vm._v(" "),
    (_vm.category || _vm.showAll) && _vm.events && _vm.events.length > 0
      ? _c("div", { staticClass: "rsp2EventNavi" }, [
          _c(
            "div",
            { staticClass: "rsp2Header" },
            [
              _c("h1", [_vm._v("Jetzt anmelden")]),
              _vm._v(" "),
              _c("DropPop", {
                attrs: { label: "Sortieren nach", items: _vm.sortByItems },
                on: {
                  select: function(item) {
                    _vm.setSort(item.value)
                  }
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              class: ((_obj = { rsp2Content: true }),
              (_obj[_vm.contentClass] = true),
              _obj)
            },
            _vm._l(_vm.events, function(event) {
              return _c("EventNaviItem", {
                key: event.id,
                staticClass: "rsp2Item",
                attrs: {
                  header: event.category,
                  title: event.title,
                  description: event.teaser,
                  url: event.url,
                  date: event.date,
                  dates: event.dates,
                  isNew: event.isNew
                }
              })
            })
          )
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }